import { useState, useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { getConsent, savePreferences, defaultConsent } from '@/utils/cookieConsent';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Switch } from '@/components/ui/switch';

export default function CookiePreferencesModal({ open, onClose }) {
  const { t } = useLanguage();
  const [prefs, setPrefs] = useState({ ...defaultConsent });

  useEffect(() => {
    if (open) {
      const current = getConsent();
      setPrefs(current?.choices || { ...defaultConsent });
    }
  }, [open]);

  const handleSave = () => {
    savePreferences(prefs);
    onClose(true);
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) handleClose(); }}>
      <DialogContent className="bg-[#F9F8F6] border-[#333333]/10 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-light text-[#333333] tracking-tight">
            {t.cookies.preferencesTitle}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t.cookies.preferencesTitle}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Essential */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1">
              <p className="text-sm font-normal text-[#333333]">{t.cookies.essential}</p>
              <p className="text-xs font-light text-[#333333]/60 mt-1">{t.cookies.essentialDesc}</p>
            </div>
            <Switch checked={true} disabled className="opacity-50" data-testid="cookie-switch-essential" />
          </div>

          {/* Analytics */}
          <div className="flex items-center justify-between gap-4">
            <div className="flex-1">
              <p className="text-sm font-normal text-[#333333]">{t.cookies.analytics}</p>
              <p className="text-xs font-light text-[#333333]/60 mt-1">{t.cookies.analyticsDesc}</p>
            </div>
            <Switch
              checked={prefs.analytics}
              onCheckedChange={(val) => setPrefs(p => ({ ...p, analytics: val }))}
              data-testid="cookie-switch-analytics"
            />
          </div>
        </div>

        <div className="flex justify-end pt-4 border-t border-[#333333]/5">
          <button
            data-testid="cookie-save-prefs"
            onClick={handleSave}
            className="px-6 py-2.5 rounded-full bg-[#35589B] text-white text-sm font-light tracking-wider hover:bg-[#2C4A85] transition-colors duration-300"
          >
            {t.cookies.save}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
